export const MINIMUM_ITEMS_TO_RENDER = 3;

export const RENDER_ANCHORED_FIX_PURCHASE_OPTIONS =
  'RENDER_ANCHORED_FIX_PURCHASE_OPTIONS';

const pdpShould = (value, state, screenSize) => {
  const isMobileScreenSize = screenSize === 'sm';
  const isSmallScreenSize = ['sm', 'md'].includes(screenSize);
  const similarItemsLength = state.recommendedCollections?.find(
    collection => collection.treatment === 'similar_items',
  )?.shopProducts?.nodes?.length;

  switch (value) {
    case 'RENDER_ADD_TO_BAG_BUTTON':
      return state.gated
        ? !state.isSkuOutOfStock && !state.selectedVariant?.saved
        : !state.isSkuOutOfStock;
    case 'RENDER_ANCHORED_FIX_PROMO':
      return state.gated && state.canScheduleAnchoredFix;
    case 'RENDER_BAG_ERROR_BANNER':
      return state.gated && state.bagError?.bagErrorMessage;
    case 'RENDER_BUSINESS_LINE_MISMATCH_BANNER':
      return (
        !state.isStaticView &&
        !state.loading &&
        state.shopProduct &&
        ((!state.eligibleForShoppingAcrossBusinessLines &&
          state.clientBusinessLineIsMismatched) ||
          state.shoppingBagBusinessLineIsMismatched)
      );
    case 'RENDER_CREDIT_INCENTIVES_BANNER':
      return (
        !state.gated &&
        state.eligibleForCreditIncentives &&
        !state.clientHasPurchases
      );
    case 'RENDER_CTAS':
      return (
        !state.loading &&
        state.shopProduct &&
        (state.eligibleForShoppingAcrossBusinessLines ||
          !state.clientBusinessLineIsMismatched) &&
        !state.shoppingBagBusinessLineIsMismatched &&
        !state.isStaticView &&
        !state.shopPurchaseOptions
      );
    case 'RENDER_DISCOVER_SKUS_COLLECTION_CAROUSELS':
      return !state.isStaticView;
    case 'RENDER_ERROR_UI':
      return (
        state.error &&
        !state.error?.message?.includes('Sellable Product Variant not found') &&
        !state.gated
      );
    case 'RENDER_GATED_BUY_NOW_BUTTON':
      return state.gated;
    case 'RENDER_HIDE_ITEM_LINK_IN_DESKTOP_POSITION':
      return (
        state.gated &&
        !isSmallScreenSize &&
        state.canHideItem &&
        String(state.selectedSkuId) === String(state.productSkuId)
      );
    case 'RENDER_HIDE_ITEM_LINK_IN_SMALL_SCREEN_POSITION':
      return (
        state.gated &&
        isSmallScreenSize &&
        state.canHideItem &&
        String(state.selectedSkuId) === String(state.productSkuId)
      );
    case 'RENDER_INVENTORY_FAILURE_ALERT':
      return (
        !state.gated &&
        !state.loading &&
        state.shopProduct &&
        state.showInventoryFailureModal
      );
    case 'RENDER_MOVE_TO_BAG_BUTTON':
      return (
        state.gated && !state.isSkuOutOfStock && state.selectedVariant?.saved
      );
    case 'RENDER_NEW_ENTRY_POINTS':
      return (
        !state.gated &&
        !state.loading &&
        state.shopProduct &&
        state.clientBusinessLine !== 'KIDS' &&
        state.clientBusinessLine !== 'SHELL' &&
        state.newEntryPoints &&
        !state.isStaticView
      );
    case 'RENDER_OUTFIT_ITEM_SELECT':
      return state.gated && !!state.pdpOutfitId && isMobileScreenSize;
    case 'RENDER_PRODUCT_ATTRIBUTES_IN_DESKTOP_POSITION':
      return !isSmallScreenSize;
    case 'RENDER_PRODUCT_ATTRIBUTES_IN_SMALL_SCREEN_POSITION':
      return isSmallScreenSize;
    case 'RENDER_PRODUCT_TITLE_DESKTOP_POSITION':
      return !isSmallScreenSize;
    case 'RENDER_PRODUCT_TITLE_IN_SMALL_SCREEN_POSITION':
      return isSmallScreenSize;
    case 'RENDER_RATE_LIMIT_FAILURE_ALERT':
      return (
        !state.gated &&
        !state.loading &&
        state.shopProduct &&
        state.showRateLimitFailureModal
      );
    case 'RENDER_SHIPPING_DETAILS':
      return !state.isStaticView;
    case 'RENDER_SHOP_CATEGORIES_CAROUSEL':
      return !state.isStaticView && !!state.shopCategoriesCards?.length;
    case 'RENDER_SIMILAR_ITEMS_LINK':
      return (
        !state.isStaticView &&
        !state.loading &&
        state.shopProduct &&
        !state.shoppingBagBusinessLineIsMismatched &&
        !state.clientBusinessLineIsMismatched &&
        similarItemsLength >= MINIMUM_ITEMS_TO_RENDER &&
        state.isSkuOutOfStock
      );
    case 'RENDER_STYLE_QUIZ_AD':
      return (
        !state.gated &&
        !state.isStaticView &&
        !state.loading &&
        state.shopProduct &&
        // We only want to show this ad to visitors, or men's and women's clients
        // who have signed up but haven't yet on-boarded.
        state.clientBusinessLine !== 'KIDS' &&
        state.clientBusinessLine !== 'SHELL' &&
        (!state.clientIsLoggedIn || state.clientNeedsOnboarding)
      );
    case 'RENDER_TWO_CTA_BUTTONS':
      return !state.isSkuOutOfStock;
    case 'RENDER_UNGATED_BUY_NOW_BUTTON':
      return !state.gated;
    case 'RENDER_WTWI_CAROUSEL_MOBILE_DIVIDER':
      return isMobileScreenSize && !state.gated && !state.newEntryPoints;
    case 'TRIGGER_LEGACY_VIEW_EVENT':
      return state.gated
        ? !state.loading &&
            !state.recommendedCollectionsLoading &&
            !state.waysToWearItLoading
        : !state.loading &&
            state.shopProduct &&
            state.priceAndInventoryData &&
            state.clientLoading;
    case 'TRIGGER_VIEW_EVENT':
      return (
        !state.loading &&
        !state.priceAndInventoryLoading &&
        !state.shopPurchaseOptionsLoading
      );
    case 'RENDER_FIX_PROMOTION':
      return state.clientIsLoggedIn && !state.clientNeedsOnboarding;
    case 'RENDER_STYLIST_CHAT_PDP_PROMPT':
      return state.clientIsLoggedIn && state.gated && isSmallScreenSize;
    case RENDER_ANCHORED_FIX_PURCHASE_OPTIONS:
      return (
        !state.loading &&
        state.shopProduct &&
        (state.eligibleForShoppingAcrossBusinessLines ||
          !state.clientBusinessLineIsMismatched) &&
        !state.shoppingBagBusinessLineIsMismatched &&
        !state.isStaticView &&
        !!state.shopPurchaseOptions
      );
    default:
      return false;
  }
};

export default pdpShould;
